module.exports = __webpack_public_path__ + "static/img/5.17235af.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/2/1/1/eng/5.png
// module id = 9AFc
// module chunks = 0